import React from 'react';
import { ArrowDownIcon, ArrowRightIcon } from 'lucide-react';
import { processSteps } from '../data/poolContent';
type ProcessStepsProps = {
  className?: string;
};
export function ProcessSteps({
  className = ''
}: ProcessStepsProps) {
  return <ol className={`flex flex-col items-center gap-2 lg:flex-row lg:justify-center lg:gap-3 ${className}`} aria-label="The Pool Care Made Easy process" data-id="element-299" data-mp="1p92bso8n3hrf">
      {processSteps.map((step, i) => <li key={step} className="flex flex-col items-center gap-2 lg:flex-row lg:gap-3" data-id="element-300" data-mp="2h22uwdg2mxi5" data-mpi={i}>
          <span className={`flex min-w-[11rem] items-center justify-center rounded-xl border px-5 py-3 font-display text-[1.35rem] font-bold uppercase tracking-[0.06em] lg:min-w-0 ${i === 0 || i === processSteps.length - 1 ? 'border-aqua bg-aqua text-abyss-950' : 'border-pool/40 bg-abyss-800 text-frost-50'}`} data-id="element-301" data-mp="2d0hjkwj6qra2">
            {step}
          </span>
          {i < processSteps.length - 1 && <>
              <ArrowDownIcon className="h-4 w-4 text-pool lg:hidden" strokeWidth={2.5} aria-hidden="true" data-id="element-302" data-mp="2r29tyzord2bi" />
              <ArrowRightIcon className="hidden h-4 w-4 text-pool lg:block" strokeWidth={2.5} aria-hidden="true" data-id="element-303" data-mp="2w2p5rmte61rd" />
            </>}
        </li>)}
    </ol>;
}